import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router'

import { Spinner } from '@/components/ui/spinner'
import { EsignEnvelope } from '../../components/EsignEnvelope'
import { useBorSignUrl } from '../../models/bor'

export function SignBor() {
  const { appId } = useParams<{ appId: string }>()
  const [signed, setSigned] = useState(false)
  const [signError, setSignError] = useState<string | null>(null)

  const { data, isError } = useBorSignUrl(appId)
  const signUrl = data?.signUrl ?? null
  const error =
    signError ??
    (isError
      ? 'We could not load your BOR envelope. Please try the link again from your email or text message.'
      : null)

  if (signed || data?.signed) {
    return (
      <>
        <Helmet>
          <title>All set</title>
        </Helmet>
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <h1 className="text-2xl font-semibold">All done.</h1>
          <p className="text-md text-gray-600">
            Your Broker of Record authorization is signed. You can close this window — we&apos;ll email you
            when your final quotes are ready.
          </p>
        </div>
      </>
    )
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center px-6 text-center">
        <p className="text-md text-red-600">{error}</p>
      </div>
    )
  }

  if (!signUrl || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center gap-2">
        <Spinner className="size-6" />
        <span className="text-md text-gray-500">Loading your document...</span>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Sign BOR</title>
      </Helmet>
      <div className="flex min-h-screen flex-col">
        <EsignEnvelope
          url={signUrl}
          onAgree={() => setSigned(true)}
          onError={() => setSignError('Signing failed. Please refresh the page.')}
        />
      </div>
    </>
  )
}
